import {
  PUSH,
  PUSH_START,
  PUSH_SUCCESS,
  UPDATE_TO,
  UPDATE_REDIRECT,
} from './constants'

const push = (to, redirect) => ({ type: PUSH, to, redirect })
const pushStart = () => ({ type: PUSH_START })
const pushSuccess = () => ({ type: PUSH_SUCCESS })
const updateTo = (to) => ({ type: UPDATE_TO, to })
const updateRedirect = (redirect) => ({ type: UPDATE_REDIRECT, redirect })
const redirect = (to) => push(to, true)
const reset = () => push('', false)

export {
  push,
  pushStart,
  pushSuccess,
  updateTo,
  updateRedirect,
  redirect,
  reset,
}
